import { all, call, put, takeEvery } from 'redux-saga/effects';
import { adminAPIURL, customHeaders } from '../../../../Containers/Config/index.js';
import apiCall from '../../apiCall.js';
import { GET_CARD_SUMMARY, GET_CARD_SUMMARY_SUCCESS, GET_CARD_SUMMARY_ERROR } from '../../../actions.js';

function* fetchCardSummary(card, startDate, endDate, payload) {
  // a card entry can optionally carry its own `ride_issue_severity` (e.g. to fetch the
  // WARNINGS/HIGH ALERTS tile counts as two parallel calls for the same card_name) - key
  // the stored result by cardName+severity so they don't clobber each other or the plain count
  const cardKey = card?.ride_issue_severity ? `${card?.name}_${card.ride_issue_severity}` : card?.name;

  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    // never mutate `payload` here - the same object reference is shared by every
    // parallel card call, so deleting keys off it corrupts the later requests
    const { cards, activeCard, ...restPayload } = payload ?? {};

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/get-card-summary/${card?.type}`,
      method: 'GET',
      headers: filteredHeaders,
      params: {
        card_name: card.name,
        ...(startDate && endDate && { start_date: startDate, end_date: endDate }),
        ...restPayload,
        ...(card?.ride_issue_severity && { ride_issue_severity: card.ride_issue_severity }),
        ...(card.name === activeCard
          ? { is_show_unassigned_bookings: restPayload?.is_show_unassigned_bookings ?? false }
          : { is_show_unassigned_bookings: false }),
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_CARD_SUMMARY_SUCCESS,
        payload: response?.data,
        meta: { cardName: cardKey },
      });
    } else {
      yield put({
        type: GET_CARD_SUMMARY_ERROR,
        payload: response.data.message,
        meta: { cardName: cardKey },
      });
    }
  } catch (error) {
    yield put({
      type: GET_CARD_SUMMARY_ERROR,
      payload: error.message,
      meta: { cardName: cardKey },
    });
  }
}

function* getCardSummarySaga({ payload }) {
  const { cards, start_date, end_date } = payload ?? {};

  // `all(undefined)` throws, and the error takes this watcher down with it - every later
  // count fetch would then silently never fire, leaving the tiles stuck on their old values
  if (!cards?.length) return;

  // Create an array of API calls
  const apiCalls = cards?.map(card => call(fetchCardSummary, card, start_date, end_date, payload));

  // Execute all API calls in parallel
  yield all(apiCalls);
}

export function* watchGetCardSummary() {
  yield takeEvery(GET_CARD_SUMMARY, getCardSummarySaga);
}

function* fetchAllCardsSaga() {
  yield all([watchGetCardSummary()]);
}

export default fetchAllCardsSaga;
